module.exports = __webpack_public_path__ + "static/media/amusement(27).8757658f.PNG";